import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export default function QuizReviewPanel({ review, onClose }) {
    if (!review) return null;

    return (
        <div className="qr-review-panel">
            <div className="qr-review-header">
                <div>
                    <h3>Relecture de la tentative</h3>
                    <p>{review.quiz?.titre}</p>
                </div>
                <button className="cr-btn cr-btn--secondary" onClick={onClose}>
                    Fermer
                </button>
            </div>

            <div className="qr-review-list">
                {(review.questions || []).map((question) => (
                    <article key={question.id} className="qr-review-question">
                        <div className="qr-review-title">
                            <strong>
                                Question {question.ordre}: {question.enonce}
                            </strong>
                            {question.pointsObtenus != null ? (
                                <span>{question.pointsObtenus} pt(s)</span>
                            ) : null}
                        </div>

                        {(question.reponsesPossibles || []).length ? (
                            <div className="qr-review-options">
                                {question.reponsesPossibles.map((option) => (
                                    <div
                                        key={option.id}
                                        className={`qr-review-option ${option.correct ? "is-correct" : ""} ${option.selected ? "is-selected" : ""}`}
                                    >
                                        {option.correct ? <CheckCircle2 size={14} /> : <XCircle size={14} />}
                                        <span>{option.libelle}</span>
                                    </div>
                                ))}
                            </div>
                        ) : null}

                        {question.submittedResponseJson && !(question.reponsesPossibles || []).length ? (
                            <div className="qr-review-text-answer">
                                <strong>Votre reponse</strong>
                                <p>{typeof question.submittedResponseJson === "string"
                                    ? question.submittedResponseJson
                                    : JSON.stringify(question.submittedResponseJson)}</p>
                            </div>
                        ) : null}

                        {question.correctAnswerText ? (
                            <div className="qr-review-text-answer">
                                <strong>Reponse attendue</strong>
                                <p>{question.correctAnswerText}</p>
                            </div>
                        ) : null}

                        {question.explicationCorrection ? (
                            <div className="qr-review-text-answer">
                                <strong>Explication</strong>
                                <p>{question.explicationCorrection}</p>
                            </div>
                        ) : null}
                    </article>
                ))}
            </div>
        </div>
    );
}
